import React from 'react';
import { useNavigate } from 'react-router-dom';
import ContentLibraryBrowser from '../components/ContentLibraryBrowser';

const ContentLibrary = () => {
  const navigate = useNavigate();

  return (
    <div>
      {/* Breadcrumb Navigation - Above Card */}
      <nav className="breadcrumb">
        <button
          onClick={() => navigate('/')}
          className="breadcrumb-link"
        >
          Dashboard
        </button>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">
          Content Library
        </span>
      </nav>

      <ContentLibraryBrowser />
    </div>
  );
};

export default ContentLibrary;
